import { action, computed, observable } from 'mobx';
import GlobalStore from '@/store/GlobalStore';
import {getOrderCenterList} from '@/services/orderCenter';
import moment from 'moment';

class orderCenterStore {
  
  @observable pageNumber = 1
  
  @observable pageSize = 100
  
  @observable totalCounts
  
  @observable toast = GlobalStore.toast
  
  // 订单中心列表
  @observable orderCenterList = []
  
  // 获取订单中心数据
  @action.bound async getOrderCenterList () {
    
    const response = await getOrderCenterList({pageNumber: this.pageNumber, pageSize: this.pageSize})
   
    if (response.code === 10000) {
      this.totalCounts = response.result.total_counts;
      this.orderCenterList = response.result.order_list.map(r => ({
        orderId: r.order_id,
        status: r.status,
        time: moment(r.order_time * 1000 ).format('YYYY-MM-DD HH:mm'),
        orderType: r.order_type === 1 ? '新主机' : '续费',
        payType: r.subject ,
        deviceId: r.cid
      }))
      return false
    }
  
    this.toast.text(response.code === 50003 ? response.msg : (response.result || response.msg))
  
  }
  
}

export default new orderCenterStore();